module.exports = __webpack_public_path__ + "img/article1.d39500de.jpg";